import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import EventsSection from './components/EventsSection';
import CategorySection from './components/CategorySection';
import ArticlesSection from './components/ArticlesSection';
import CTASection from './components/CTASection';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: '开云爱体育',
      url: 'https://www.kaiyunsports.com/',
      description: '开云爱体育是专业体育竞技娱乐平台，汇聚全球顶级赛事资源，提供多元化体育项目体验。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.kaiyunsports.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '开云爱体育',
      url: 'https://www.kaiyunsports.com/',
      description: '开云爱体育是专业体育竞技娱乐平台，汇聚全球顶级赛事资源，提供多元化体育项目体验。',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+86-400-888-9999',
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
      address: {
        '@type': 'PostalAddress',
        addressLocality: '北京',
        addressRegion: '朝阳区',
        streetAddress: '建国路88号',
      },
    },
    {
      '@type': 'WebPage',
      url: 'https://www.kaiyunsports.com/',
      name: '开云爱体育 - 官方体育竞技平台',
      description: '开云爱体育是专业体育竞技娱乐平台，汇聚全球顶级赛事资源，提供多元化体育项目体验。',
      isPartOf: {
        '@id': 'https://www.kaiyunsports.com/#website',
      },
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'https://www.kaiyunsports.com/',
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(homeJsonLd)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <EventsSection />
        <CategorySection />
        <ArticlesSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}